/* Seitenverhältnis des Videos an das Fenster weitergeben (Hoch- und Querformat) */
(function () {
  'use strict';
  function setzen(v) {
    var w = v.closest('.video-wrapper--modal');
    if (!w || !v.videoWidth || !v.videoHeight) return;
    w.style.setProperty('--av-vr', v.videoWidth + ' / ' + v.videoHeight);
    w.style.setProperty('--av-vw', v.videoWidth);
    w.style.setProperty('--av-vh', v.videoHeight);
  }
  document.addEventListener('loadedmetadata', function (e) {
    if (e.target && e.target.tagName === 'VIDEO') setzen(e.target);
  }, true);
  /* YouTube-Shorts (Hochformat) verraten ihr Format nicht, deshalb hier eintragen */
  var SHORTS = ['fS8j3Giv4Is'];
  function iframe(f) {
    var w = f.closest('.video-wrapper--modal');
    if (!w) return;
    var hoch = SHORTS.some(function (id) { return (f.src || '').indexOf(id) > -1; });
    w.style.setProperty('--av-vr', hoch ? '9 / 16' : '16 / 9');
    w.style.setProperty('--av-vw', hoch ? 9 : 16);
    w.style.setProperty('--av-vh', hoch ? 16 : 9);
  }
  setInterval(function () {
    document.querySelectorAll('.video-wrapper--modal iframe').forEach(iframe);
    document.querySelectorAll('.video-wrapper--modal video').forEach(setzen);
  }, 1000);
})();
